import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, Typography } from '@chilecompra/react-kit'
import { ANTIUNION_PRACTICES, DISABILITY_REASONS } from '../../config/settings/constant'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'
import { DialogContent, DialogMessage, Strong } from './AbilityStatusSection.styles'

/**
 * The ability status section modal component.
 */
const AbilityStatusSectionModal = ({ isOpen, onClose, onOpenModal, disability }) => {
  return (
    <Dialog maxWidth="750px" open={isOpen} position="relative" onClose={onClose} onOpen={onOpenModal}>
      <DialogContent>
        <DialogMessage>
          <Typography fontWeight="bold" variant="h4">
            ¿Cómo se resuelve esta inhabilidad?
          </Typography>
          <Typography fontWeight="bold" margin="28px 0 8px" variant="body1">
            <ProtectByFeatures rule={features => features['com.seller/antiunion.practices.visible']}>
              {disability === 'PRÁCTICAS ANTISINDICALES'
                ? ANTIUNION_PRACTICES[disability]?.title
                : DISABILITY_REASONS[disability]?.title}
            </ProtectByFeatures>
            <ProtectByFeatures rule={features => features['com.seller/antiunion.practices.not.visible']}>
              {DISABILITY_REASONS[disability]?.title}
            </ProtectByFeatures>
          </Typography>

          {DISABILITY_REASONS[disability]?.howIsItSolved?.map((paragraph, j) => {
            return (
              <Typography key={j} margin="8px 0 0" variant="body2">
                {paragraph}
              </Typography>
            )
          })}

          {DISABILITY_REASONS[disability]?.duration !== '' && (
            <Typography margin="8px 0 0" variant="body2">
              <Strong>Duración: </Strong>
              {DISABILITY_REASONS[disability]?.duration}
            </Typography>
          )}
        </DialogMessage>
      </DialogContent>
    </Dialog>
  )
}

AbilityStatusSectionModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onOpenModal: PropTypes.func,
  disability: PropTypes.string
}

export default AbilityStatusSectionModal
